module.exports = __webpack_public_path__ + "static/media/0328_IMG_LES_ENSEIGNES_LE_PRIMEUR_LETTRE_A_LETTRE.95bdc1d4.webp";